import {isNil} from 'ramda';

import {Nullish} from '../../types/Nullish';

/**
 * The quoted and bare forms. RFC 5987 `filename*` is deliberately not parsed: a backend
 * that percent-encodes the name is telling us it is not plain ASCII, and the caller's own
 * fallback is the safer file name.
 */
const FILE_NAME_PATTERN = /filename\s*=\s*(?:"([^"]*)"|([^;]*))/i;

/**
 * Reads the download name a `Content-Disposition` header carries, or null when the header
 * is absent or names nothing. The header is only readable cross-origin when the response
 * also sends `Access-Control-Expose-Headers: Content-Disposition`, so a caller must always
 * have a fallback.
 */
export function getContentDispositionFileName(header: string | Nullish): string | null {
  if (isNil(header)) {
    return null;
  }

  const [, quoted, bare] = FILE_NAME_PATTERN.exec(header) ?? [];
  const fileName = (quoted ?? bare ?? '').trim();

  return fileName === '' ? null : fileName;
}
